import { z } from 'zod'

export const SecurityTargetSourceSchema = z.enum(['observed', 'conventional', 'derived', 'unrecorded'])
export const SecurityScanTargetSchema = z.object({
  url: z.string(), method: z.string().default('GET'), params: z.array(z.string()).default([]),
  id_params: z.array(z.string()).optional(), idParams: z.array(z.string()).optional(),
  source: SecurityTargetSourceSchema.optional(),
})
export const SecurityScanFindingSchema = z.object({
  id: z.string().optional(), kind: z.string(), severity: z.string(),
  element: z.string().nullish(), description: z.string().nullish(),
  bug_ids: z.array(z.string()).optional(),
})
export const SecurityFindingBugSchema = z.object({ finding_id: z.string(), bug_id: z.string() })
const FilingSubmissionSchema = z.object({
  status: z.literal('completed'), created_bug_id: z.string().nullish(),
  result: z.object({ existing_bug_id: z.string().optional(), bug: z.object({ id: z.string() }).optional() }).nullish(),
})
export function securityFiledBugId(submission: unknown): string | undefined {
  const parsed = FilingSubmissionSchema.safeParse(submission)
  if (!parsed.success) return undefined
  return parsed.data.created_bug_id ?? parsed.data.result?.existing_bug_id ?? parsed.data.result?.bug?.id
}

/** Targets and findings are stored independently from request transcripts and response evidence. */
export function securityScanRecords(output: Record<string, unknown>) {
  const targets = z.array(SecurityScanTargetSchema).parse(output.targets_identified ?? [])
  const findings = z.array(SecurityScanFindingSchema).parse(output.security_findings ?? [])
  return { targets, findings: findings.map((finding, index) => ({ ...finding, id: String(index) })) }
}
